interface Props {
  width: number;
  height: number;
  className?: string;
}

export const SyncWithLogo = (props: Props) => {
  const { width, height, className } = props;
  return (
    <img
      src="/images/syncwith-logo2.png"
      alt="SyncWith Logo"
      className={className}
      width={width}
      height={height}
    />
  );
};
